import React from "react";
import RefundDashboard from "./components/RefundDashboard";

class RefundModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 0,
      props: null,
      dashboardKey: 0,
      dashboardKeyReload: 0,
    };
  }

  setView = (v, p) => {
    this.setState({ view: v, props: p });
  };
  resetDashboard = () => {
    this.setState((prev) => ({ dashboardKey: prev.dashboardKey + 1 }));
  };
  resetDashboardReload = () => {
    this.setState((prev) => ({
      dashboardKeyReload: prev.dashboardKeyReload + 1,
    }));
  };

  render() {
    return (
      <>
        <div style={{ display: this.state.view === 0 ? "block" : "none" }}>
          <RefundDashboard
            key={this.state.dashboardKey}
            setView={this.setView}
            data={this.state.props}
            history={this.props.history}
            dashboardKeyReload={this.state.dashboardKeyReload}
          />
        </div>
      </>
    );
  }
}

export default RefundModule;
